import { authApi } from "@api";
import { ComponentMenuBar } from "@components";
import { useEffect, useRef, useState } from "react";
import { useFullScreen } from "src/Helpers/useFullscreen";
import styled from "styled-components";

export function PageCrypto() {
    const height = useFullScreen();
    const iframeRef = useRef<HTMLIFrameElement>(null);
    const [token, setToken] = useState<string | null>(null);

    const sendMessageToIframe = (message: any) => {
        const maxRetries = 3;
        let attempts = 0;

        const trySendMessage = () => {
            if (iframeRef.current?.contentWindow) {
                iframeRef.current.contentWindow.postMessage(message, "*");

                // // Set a timeout to check for a response
                // setTimeout(() => {
                //     if (!useCache.getState().cryptoRefreshed && attempts < maxRetries) {
                //         attempts++;
                //         trySendMessage(); // Retry sending the message
                //     } else if (!useCache.getState().cryptoRefreshed) {
                //         console.error("Max retries reached. Message not sent.");
                //     }
                // }, 2000); // Wait 2 seconds before retrying
            }
        };

        trySendMessage();
    };

    const handleMessage = (event: MessageEvent) => {
        if (event.origin !== "https://pinkcoin.ai") return;
        console.log("Received message:", event.data);

        // if (event.data.success) {
        //     window.location.reload();
        // }
    };

    const fetchToken = async () => {
        try {
            //getUser
            const user = await authApi.getInfo();
            const response = await authApi.generateCryptoToken({
                user_id: user.data._id,
                email: user.data.email,
                full_name: user.data.fullName,
                phone: user.data.phoneNumber,
                lineuserid: user.data.lineUserId,
                address_line_1: "ROCKET",
                address_line_2: "CRM",
                city: "Bangkok",
                tel: user.data.phoneNumber,
                state: "Bangkok",
                postal_code: "10120",
                country: "Thailand",
                sub_district: "Sathorn",
                sub: "CRM",
            });
            const data = await response.data;
            // console.log("TOKEN SET", data.cryptoJwt);
            setToken(data.cryptoJwt);
        } catch (error) {
            console.error("Error fetching token:", error);
        }
    };

    //Mount
    useEffect(() => {
        window.addEventListener("message", handleMessage);
        return () => {
            window.removeEventListener("message", handleMessage);
        };
    }, []);

    useEffect(() => {
        if (token) {
            sendMessageToIframe({
                type: "Authentication",
                data: `${token}`,
            });
            console.log("Message sent!", token);
        }
    }, [token]);

    return (
        <Container {...{ height }}>
            <iframe
                onLoad={async () => await fetchToken()}
                ref={iframeRef}
                src="https://pinkcoin.ai/swap"
                width="100%"
                height="100%"
                allow="camera; microphone; payment"
                style={{ border: "none", overflow: "hidden", backgroundColor: "white" }}
            />
            <ComponentMenuBar />
        </Container>
    );
}

const Container = styled.div<{ height: string }>`
    display: flex;
    flex: 1;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: ${(p) => p.height};
`;
